<template>
  <div></div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data: function () {
    return {
      loading: true
    }
  },
  mounted: async function () {
    this.$store.dispatch('loading')
    const vm = this
    if (this.$route.query.code) {
      try {
        await this.saveLineNotify(this.$route.query.code)

        if (vm.$route.query.state && window.location.hostname == 'qualityexpress.zwiz.ai') {
          window.location = 'line://app/1594960270-3dRePVdk?close=true'
        } else {
          vm.$router.push('/' + vm.currentLang + '/setting')
        }

        this.$store.dispatch('loading')
        this.$router.push('/' + this.currentLang + '/setting')
      } catch (error) {
        if (vm.$route.query.state && window.location.hostname == 'qualityexpress.zwiz.ai') {
          window.location = 'line://app/1594960270-3dRePVdk?close=true'
        } else {
          vm.$router.push('/' + vm.currentLang + '/setting')
        }
      }
    } else {
      vm.$store.dispatch('loading')
      if (vm.$route.query.state && window.location.hostname == 'qualityexpress.zwiz.ai') {
        window.location = 'line://app/1594960270-3dRePVdk?close=true'
      } else {
        vm.$router.push('/' + vm.currentLang + '/allbots')
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    saveLineNotify: function (code) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          code: code,
          redirect_uri:
            window.location.protocol +
            '//' +
            window.location.hostname +
            (window.location.port ? ':' + window.location.port : '') +
            '/linenotify'
        }
        if (vm.$route.query.state && window.location.hostname == 'qualityexpress.zwiz.ai') {
          data.adminid = vm.$route.query.state
          var pageid = vm.$route.query.state.split('__')
          if (pageid.length > 1) {
            data.pageid = pageid[1]
          } else {
            reject()
          }
        } else {
          data.adminid = vm.$store.state.userid
          data.pageid = vm.selectedBot.pageid
        }

        api.saveLineNotify(data, function (error, response) {
          if (error) {
            reject(error)
          }

          resolve()
        })
      })
    },
    saveLineNotifyInflu: function (code) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.selectedBot.pageid,
          adminid: vm.$store.state.userid,
          code: code,
          redirect_uri:
            window.location.protocol +
            '//' +
            window.location.hostname +
            (window.location.port ? ':' + window.location.port : '') +
            '/linenotify'
        }
        api.saveLineNotify(data, function (error, response) {
          if (error) {
            reject(error)
          }

          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/linenotify/Linenotify.vue